import { render, staticRenderFns } from "./workOrderCard.vue?vue&type=template&id=70d2a5cf&scoped=true&"
import script from "./workOrderCard.vue?vue&type=script&lang=js&"
export * from "./workOrderCard.vue?vue&type=script&lang=js&"
import style0 from "./workOrderCard.vue?vue&type=style&index=0&id=70d2a5cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d2a5cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d2a5cf')) {
      api.createRecord('70d2a5cf', component.options)
    } else {
      api.reload('70d2a5cf', component.options)
    }
    module.hot.accept("./workOrderCard.vue?vue&type=template&id=70d2a5cf&scoped=true&", function () {
      api.rerender('70d2a5cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/patrolWorkOrderMgr/mobile/components/workOrderCard.vue"
export default component.exports